import BaseAPIClient from './base/BaseAPIClient';

export default class ChatClient extends BaseAPIClient {
  getConversation() {
    return this._get('chat/conversation/');
  }

  getMessages(conversationId, limit = 50, offset = 0, ordering = '-created') {
    return this._get(`chat/conversation/${conversationId}/messages/`, { limit, offset, ordering });
  }

  sendMessage(conversationId, content) {
    return this._post(`chat/conversation/${conversationId}/messages/create/`, { content });
  }
}
